(() => {
  const root = document.querySelector("main [data-testid='product-information']");
  if (!root || root.dataset.pwPricePolishReady === 'true') return;
  root.dataset.pwPricePolishReady = 'true';

  const priceSelector = '.product-information__grid .price, .sticky-add-to-cart__price .price';
  const normalizePrice = (node) => {
    const raw = node.textContent.trim();
    const match = raw.match(/^\$([\d,]+)(?:\.00)?$/);
    if (!match) return;
    node.textContent = `NT$${match[1]}`;
    node.setAttribute('aria-label', `新台幣 ${match[1]} 元`);
  };

  const normalizeAllPrices = () => root.querySelectorAll(priceSelector).forEach(normalizePrice);
  const ensureRestockCta = () => {
    if (root.querySelector('.kp-pw26__restock-cta')) return;
    const template = document.querySelector('template[data-pw-restock-cta-template]');
    const productForm = root.querySelector('.product-information__grid product-form-component');
    if (!template || !productForm || !template.content.firstElementChild) return;
    productForm.append(template.content.firstElementChild.cloneNode(true));
  };

  const refresh = () => {
    normalizeAllPrices();
    ensureRestockCta();
  };

  refresh();

  new MutationObserver(refresh).observe(root, {
    childList: true,
    characterData: true,
    subtree: true,
  });
})();
